import {Platform} from 'react-native';
import {useSafeAreaInsets} from 'react-native-safe-area-context';

/**
 * Returns the bottom safe area inset on Android (edge-to-edge), 0 elsewhere.
 * iOS handles bottom insets via SafeAreaView at a higher level (DrawerNavigator).
 * Web always returns 0.
 */
export function useEdgeToEdgeBottomInset(): number {
  const insets = useSafeAreaInsets();
  return Platform.OS === 'android' ? insets.bottom : 0;
}
